import { initCreate } from './create';
import { initWorkflow } from './workflow';

/**
 * Adds global/static methods to the public WebViewer object.
 * @param Vue
 */
export function initGlobalApi (Vue) {
  initCreate(Vue);
  initWorkflow(Vue);
}



// WEBPACK FOOTER //
// ./src/viewer/core/global-api/index.js